module.exports = __webpack_public_path__ + "img/GUSD.b860ecc3.svg";